import { Button } from 'primitives/button'
import { Stack } from 'primitives/containers'
import React, { useContext } from 'react'
import { useSelector } from 'react-redux'

import { WidgetHeaderBar } from '../../../components/live_chat_widget/widget_header_bar'
import {
  getCurrentAnswers,
  getCurrentQuestion,
} from '../../../reduxes/slices/questions/selectors'
import { questionContainerStyles, spacerStyles } from './styles'
import {WidgetContext} from "../widget_page_router";

export const MultiChoice = () => {
  const currentQuestion = useSelector(getCurrentQuestion)
  const answers = useSelector(getCurrentAnswers)
  const { handleAnswerAction } = useContext(WidgetContext)

  return (
    <>
      <WidgetHeaderBar />
      <div className={spacerStyles()} />
      <Stack
        gap={2}
        className={questionContainerStyles()}
        css={{
          justifyContent: 'space-between',
          padding: '$4',
          zIndex: 1,

          h2: {
            textAlign: 'center',
          },
        }}
      >
        <h2>{currentQuestion.text}</h2>
        <Stack
          as={'ul'}
          gap={2}
          css={{
            color: 'black',

            button: {
              width: '100%',
            },
          }}
        >
          {answers.map((a) => (
            <li key={a.id}>
              <Button
                variant={'primary'}
                onClick={() => handleAnswerAction(a)}
              >
                {a.text}
              </Button>
            </li>
          ))}
        </Stack>
      </Stack>
    </>
  )
}
